import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import homeLayout from "../layouts/homeLayout";
import adminLayout from "@/layouts/adminLayout";
import superAdminLayout from "@/layouts/superAdminLayout";
import homeRoutes from "@/router/routes/homeRoutes";
import adminRoutes from "@/router/routes/adminRoutes";
import sAdminRoutes from "@/router/routes/sAdminRoutes";
import auth from "@/router/middleware/auth";
import guest from "@/router/middleware/guest";
import middlewarePipeline from "@/router/middleware/middlewarePipeline";
import store from '../store/index'
import isClient from "@/router/middleware/isClient";
import agentLayout from "@/layouts/agentLayout";
import agentRoutes from "@/router/routes/agentRoutes";
import clientViewDashboard from "@/views/client/ClientViewDashboard";
import clientViewRoutes from "@/router/routes/clientViewRoutes";
import clientLayout from "@/layouts/clientLayout";

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        component: homeLayout,
        children: [
            ...homeRoutes
        ],
        meta: {
            middleware: [
                guest
            ]
        },
    },
    {
        path: '/user',
        component: adminLayout,
        children: [
            ...adminRoutes
        ],
        meta: {
            middleware: [
                auth, isClient
            ]
        },
    },
    {
        path: '/admin',
        component: superAdminLayout,
        children: [
            ...sAdminRoutes
        ],
        meta: {
            middleware: [
                auth
            ]
        },
    },
    {
        path: '/agent',
        component: agentLayout,
        children: [
            ...agentRoutes
        ],
        meta: {
            middleware: [
                guest
            ]
        },
    },
    {
        path: '/client',
        component: clientLayout,
        children: [
            ...clientViewRoutes
        ],
        meta: {
            middleware: [
                auth
            ]
        },
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    // NProgress.start();
    const nearestWithMiddleware = to.matched.slice().reverse().find(r => r.meta && r.meta.middleware);
    if (!nearestWithMiddleware) {
        return next()
    }
    const middleware = nearestWithMiddleware.meta.middleware;

    const context = {
        to,
        from,
        next,
        store,
        router
    };
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    });
});

router.afterEach((to, from) => {
    // NProgress.done();
});
export default router;
